<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" header-classes="pb-1" body-classes="px-0 pt-0 pb-0" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">
              <b-col sm="12" md="6" lg="4" class="d-flex align-items-right flex-wrap pt-2">
                <p class="mb-0 mr-2 text-sm">Show</p>

                <el-select class="select-primary pagination-select" v-model="perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>

                <p class="mb-0 ml-2 text-sm">records</p>

              </b-col>
            </b-row>
          </template>
          <div style="position: relative">

            <div v-show="this.loading" class="loading">
                  <loading-panel></loading-panel>
            </div>
            <el-table :data="history"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results"
              v-if="view === 'table'">

              <el-table-column label="Date Viewed" min-width="151px" prop="date" sortable>
                <template v-slot="{ row }">
                  <span class="font-weight-600">{{ dateFormat(row.createdOn) }}</span>
                </template>
              </el-table-column>

              <el-table-column label="Recipe" min-width="621px" prop="name" sortable>
               <template v-slot="{ row }">
                   <b-media no-body class="align-items-center" v-if="row.recipe">
                    <a :href="'/recipe/' + row.recipe.id" class="avatar mr-3 table__avatar" :class="(!row.image)?'avatar--grey':' rounded-circle'">
                     <b-img :src="row.recipe && row.recipe.image ? row.recipe.image.absoluteUri : 'img/DefaultUser.gif'" rounded="circle" class="avatar-sm mr-2"/>    
                     <span v-if="row.recipe && !row.recipe.image">{{ row.recipe.name.charAt(0) }}</span>      
                    </a>
                    <b-media-body class="table__title-wrapper" v-if="row.recipe">
                      <a :href="'/recipe/' + row.recipe.id">
                          <span class="font-weight-600 name mb-0 text-sm">{{ row.recipe.name }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Author" min-width="126px" prop="author" sortable>
                <template v-slot="{row}">
                  <b-img :src="row.recipe && row.recipe.user && row.recipe.user.image ? row.recipe.user.image.absoluteUri : 'img/DefaultUser.gif'" rounded="circle" class="avatar-sm mr-2" v-if="row.recipe" />
                </template>
              </el-table-column>

            </el-table>
            <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                  <div class="">
                    <p class="card-category">
                      Showing {{ from + 1 }} to {{ to }} of {{ count }} entries
                    </p>
                  </div>
                  <base-pagination
                    class="pagination-no-border"
                    :current="currentPage"
                    :per-page="perPage"
                    :total="count"
                    @change="paginationChanged($event)"
                  >
                  </base-pagination>
            </div>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
import LoadingPanel from '@/components/LoadingPanel.vue';
import swal from 'sweetalert2';

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      data: null,
      itemLimit: '10',
      view: 'table',
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      currentDate: ''
    };
  },
  computed: {
     history() {
      return this.$store.state.reportings.history.results
     },
     isLoading() {
       return this.$store.state.reportings.loading;
     },
     to() {
      let highBound = this.from + this.perPage;
      if (this.count < highBound) {
        highBound = this.count;
      }
      return highBound;
    },
    from() {
      return this.perPage * (this.currentPage - 1);
    },
    count() {
      return this.$store.state.reportings.history.count;
    }
  },
  methods: {
    dateFormat(date) {
      var local = new Date(date);
      return local.toLocaleDateString("en-US");
    },
    paginationChanged(page) {
      this.currentPage = page;
      this.searchHistory();
    },
    searchHistory() {
      const { dispatch } = this.$store;
      var payload = {
        "userId": this.$store.state.authentication.user.user.id,
        "page": this.currentPage,
        "pageSize": this.perPage,
        "query": this.sq
      }

      dispatch("reportings/getUserHistory", payload);
    },
    toggleActive(event, view) {
      event.preventDefault();

      const button = event.target.closest('.btn-view');
      const card = document.querySelector('.card-results');

      button.classList.add('active')

      Array.prototype.filter.call(button.parentNode.children, function(child){
        if (child !== button) {
          child.classList.remove('active')
        }
      });

      this.view = view;

      this.view == 'grid'
        ? card.classList.add('card-results--alt')
        : card.classList.remove('card-results--alt')
    }
  },
  created() {
    this.searchHistory();
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchHistory();
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
